// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Profile Page - Tavern Theme */

.profile-page {
  /* background inherited from body wood texture */
}

.profile-page .ttbPageTitle {
  color: var(--color-fire-500);
  font-family: var(--font-heading);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  border-bottom: 2px solid var(--color-fire-600);
  padding-bottom: var(--space-3);
  margin-bottom: var(--space-6);
}

.profile-page-title {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

/* Profile header — MemberItem-style avatar */
.profile-card {
  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);
  border: 3px solid var(--color-wood-800);
  border-radius: var(--radius-xl);
  padding: var(--space-6);
  margin-bottom: var(--space-4);
  text-align: center;
  box-shadow: 0 4px 16px rgba(109, 76, 41, 0.35);
}

.profile-avatar-wrap {
  position: relative;
  width: 96px;
  height: 96px;
  margin: 0 auto var(--space-4);
}

.profile-avatar-wrap::after {
  content: '';
  position: absolute;
  right: 2px;
  bottom: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #4caf50;
  border: 2.5px solid var(--color-parchment-100);
  z-index: 1;
}

.profile-avatar-img {
  width: 96px;
  height: 96px;
  line-height: 0;
}

.profile-avatar-img img {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  border: 3px solid var(--color-wood-600);
}

.profile-avatar-placeholder {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: var(--color-wood-300, #c4a570);
  border: 3px solid var(--color-wood-600);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: var(--color-wood-800, #5a3e1b);
  font-weight: 700;
}

.profile-role-badge {
  position: absolute;
  bottom: -4px;
  right: -4px;
  z-index: 2;
}

.profile-role-badge .mi-role-badge {
  min-width: 36px;
  width: 36px;
  height: 36px;
  margin: 0;
  border-width: 2.5px;
  font-size: 18px;
}

.profile-user-name {
  font-family: var(--font-heading);
  font-size: 24px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: var(--space-2);
}

.profile-user-role {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-secondary);
  margin-bottom: var(--space-4);
}

.profile-key-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-4);
  margin-bottom: var(--space-4);
  background: var(--color-parchment-100);
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
}

.profile-key-copy {
  min-width: 0;
}

.profile-key-title {
  color: var(--color-text-primary);
  font-weight: 700;
}

.profile-key-description {
  margin-top: var(--space-1);
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 1.4;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-3);
  margin-top: var(--space-4);
}

.stat-item {
  text-align: center;
  padding: var(--space-3);
  background: rgba(184, 71, 14, 0.05);
  border-radius: var(--radius-md);
}

.stat-value {
  font-family: var(--font-heading);
  font-size: 24px;
  font-weight: 700;
  color: var(--color-fire-600);
}

.stat-label {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin-top: var(--space-1);
}

/* Legacy profile header */
.profile-header {
  display: flex;
  gap: var(--space-3);
  align-items: center;
}

.profile-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--color-fire-600);
  box-shadow: var(--shadow-md);
}

.profile-avatar-fallback {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 3px solid var(--color-fire-600);
  background: var(--color-wood-700);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 900;
  color: var(--color-fire-500);
  font-family: var(--font-heading);
  box-shadow: var(--shadow-md);
}

.profile-name {
  font-size: 20px;
  font-weight: 700;
  font-family: var(--font-heading);
  color: var(--color-text-primary);
  line-height: 1.2;
}

.profile-meta {
  margin-top: var(--space-2);
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
}

/* Club info section */
.club-info-card {
  background: var(--color-parchment-100);

  /* Parchment texture */
  background-image:
    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),
    repeating-linear-gradient(
      0deg,
      transparent,
      transparent 2px,
      rgba(139, 69, 19, 0.06) 2px,
      rgba(139, 69, 19, 0.06) 3px
    ),
    repeating-linear-gradient(
      90deg,
      transparent,
      transparent 100px,
      rgba(160, 82, 45, 0.03) 100px,
      rgba(160, 82, 45, 0.03) 101px
    );

  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  padding: var(--space-5);
  margin-bottom: var(--space-4);
}

.club-info-title {
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 700;
  color: var(--color-fire-600);
  margin-bottom: var(--space-4);
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  margin-bottom: var(--space-3);
  padding-bottom: var(--space-3);
  border-bottom: 1px solid var(--color-wood-600);
}

.info-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.info-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.info-content {
  flex: 1;
}

.info-label {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin-bottom: var(--space-1);
}

.info-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.contact-button {
  width: 100%;
  margin-top: var(--space-4);
  background: var(--color-fire-600);
  color: var(--color-parchment-100);
  border: none;
  border-radius: var(--radius-lg);
  padding: var(--space-3) var(--space-4);
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all var(--transition-fast);
  box-shadow: 0 2px 4px rgba(26, 20, 16, 0.2);
}

.contact-button:hover {
  background: var(--color-fire-700);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(26, 20, 16, 0.3);
}

.contact-button:active {
  transform: translateY(0);
}

/* Legacy club info section */
.club-section-title {
  font-size: 16px;
  font-weight: 700;
  font-family: var(--font-heading);
  color: var(--color-fire-500);
  margin-bottom: var(--space-4);
  padding-bottom: var(--space-2);
  border-bottom: 1px solid var(--color-wood-600);
}

.club-info-grid {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.club-info-item {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.club-info-label {
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.club-info-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  line-height: 1.4;
}

.club-contacts {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.club-divider {
  height: 1px;
  background: var(--color-wood-600);
  margin: var(--space-1) 0;
}

/* Map link */
.map-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  margin-top: var(--space-3);
  padding: var(--space-2) var(--space-4);
  font-size: 13px;
  font-weight: 600;
  color: var(--color-parchment-100);
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border: none;
  border-radius: var(--radius-lg);
  text-decoration: none;
  transition: all var(--transition-fast);
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.3);
}

.map-link:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.4);
}

.map-link:active {
  transform: translateY(0);
}

/* Developer section */
.developer-section {
  margin-top: var(--space-4);
  padding-top: var(--space-4);
  border-top: 1px dashed var(--color-wood-600);
}

.developer-hint {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin-bottom: var(--space-3);
  line-height: 1.4;
}

.contact-button--developer {
  background: var(--color-wood-700);
  margin-top: 0;
}

.contact-button--developer:hover {
  background: var(--color-wood-800);
}

@media (min-width: 768px) {
  .profile-content {
    max-width: 640px;
    margin: 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profile/ProfilePage.css"],"names":[],"mappings":"AAEA,gCAAgC;;AAEhC;EACE,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,2CAA2C;EAC3C,8CAA8C;EAC9C,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,6DAA6D;EAC7D,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,sCAAsC;;EAEtC,sBAAsB;EACtB;;;;;;;;;;;;;;;;;KAiBG;;EAEH,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,iCAAiC;EACjC,iCAAiC;EACjC,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;EAC7B,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,6DAA6D;EAC7D,YAAY;EACZ,+BAA+B;EAC/B,qBAAqB;EACrB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF","sourcesContent":["@import '../_base.css';\n\n/* Profile Page - Tavern Theme */\n\n.profile-page {\n  /* background inherited from body wood texture */\n}\n\n.profile-page .ttbPageTitle {\n  color: var(--color-fire-500);\n  font-family: var(--font-heading);\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n  border-bottom: 2px solid var(--color-fire-600);\n  padding-bottom: var(--space-3);\n  margin-bottom: var(--space-6);\n}\n\n.profile-page-title {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n/* Profile header — MemberItem-style avatar */\n.profile-card {\n  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);\n  border: 3px solid var(--color-wood-800);\n  border-radius: var(--radius-xl);\n  padding: var(--space-6);\n  margin-bottom: var(--space-4);\n  text-align: center;\n  box-shadow: 0 4px 16px rgba(109, 76, 41, 0.35);\n}\n\n.profile-avatar-wrap {\n  position: relative;\n  width: 96px;\n  height: 96px;\n  margin: 0 auto var(--space-4);\n}\n\n.profile-avatar-wrap::after {\n  content: '';\n  position: absolute;\n  right: 2px;\n  bottom: 2px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #4caf50;\n  border: 2.5px solid var(--color-parchment-100);\n  z-index: 1;\n}\n\n.profile-avatar-img {\n  width: 96px;\n  height: 96px;\n  line-height: 0;\n}\n\n.profile-avatar-img img {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  object-fit: cover;\n  display: block;\n  border: 3px solid var(--color-wood-600);\n}\n\n.profile-avatar-placeholder {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  background: var(--color-wood-300, #c4a570);\n  border: 3px solid var(--color-wood-600);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  color: var(--color-wood-800, #5a3e1b);\n  font-weight: 700;\n}\n\n.profile-role-badge {\n  position: absolute;\n  bottom: -4px;\n  right: -4px;\n  z-index: 2;\n}\n\n.profile-role-badge .mi-role-badge {\n  min-width: 36px;\n  width: 36px;\n  height: 36px;\n  margin: 0;\n  border-width: 2.5px;\n  font-size: 18px;\n}\n\n.profile-user-name {\n  font-family: var(--font-heading);\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-2);\n}\n\n.profile-user-role {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  margin-bottom: var(--space-4);\n}\n\n.profile-key-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-4);\n  margin-bottom: var(--space-4);\n  background: var(--color-parchment-100);\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n}\n\n.profile-key-copy {\n  min-width: 0;\n}\n\n.profile-key-title {\n  color: var(--color-text-primary);\n  font-weight: 700;\n}\n\n.profile-key-description {\n  margin-top: var(--space-1);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: var(--space-3);\n  margin-top: var(--space-4);\n}\n\n.stat-item {\n  text-align: center;\n  padding: var(--space-3);\n  background: rgba(184, 71, 14, 0.05);\n  border-radius: var(--radius-md);\n}\n\n.stat-value {\n  font-family: var(--font-heading);\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--color-fire-600);\n}\n\n.stat-label {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  margin-top: var(--space-1);\n}\n\n/* Legacy profile header */\n.profile-header {\n  display: flex;\n  gap: var(--space-3);\n  align-items: center;\n}\n\n.profile-avatar {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid var(--color-fire-600);\n  box-shadow: var(--shadow-md);\n}\n\n.profile-avatar-fallback {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  border: 3px solid var(--color-fire-600);\n  background: var(--color-wood-700);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  font-weight: 900;\n  color: var(--color-fire-500);\n  font-family: var(--font-heading);\n  box-shadow: var(--shadow-md);\n}\n\n.profile-name {\n  font-size: 20px;\n  font-weight: 700;\n  font-family: var(--font-heading);\n  color: var(--color-text-primary);\n  line-height: 1.2;\n}\n\n.profile-meta {\n  margin-top: var(--space-2);\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  flex-wrap: wrap;\n}\n\n/* Club info section */\n.club-info-card {\n  background: var(--color-parchment-100);\n\n  /* Parchment texture */\n  background-image:\n    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),\n    repeating-linear-gradient(\n      0deg,\n      transparent,\n      transparent 2px,\n      rgba(139, 69, 19, 0.06) 2px,\n      rgba(139, 69, 19, 0.06) 3px\n    ),\n    repeating-linear-gradient(\n      90deg,\n      transparent,\n      transparent 100px,\n      rgba(160, 82, 45, 0.03) 100px,\n      rgba(160, 82, 45, 0.03) 101px\n    );\n\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  padding: var(--space-5);\n  margin-bottom: var(--space-4);\n}\n\n.club-info-title {\n  font-family: var(--font-heading);\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--color-fire-600);\n  margin-bottom: var(--space-4);\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.info-item {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  margin-bottom: var(--space-3);\n  padding-bottom: var(--space-3);\n  border-bottom: 1px solid var(--color-wood-600);\n}\n\n.info-item:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.info-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.info-content {\n  flex: 1;\n}\n\n.info-label {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  margin-bottom: var(--space-1);\n}\n\n.info-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.contact-button {\n  width: 100%;\n  margin-top: var(--space-4);\n  background: var(--color-fire-600);\n  color: var(--color-parchment-100);\n  border: none;\n  border-radius: var(--radius-lg);\n  padding: var(--space-3) var(--space-4);\n  font-family: var(--font-body);\n  font-size: 14px;\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  box-shadow: 0 2px 4px rgba(26, 20, 16, 0.2);\n}\n\n.contact-button:hover {\n  background: var(--color-fire-700);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(26, 20, 16, 0.3);\n}\n\n.contact-button:active {\n  transform: translateY(0);\n}\n\n/* Legacy club info section */\n.club-section-title {\n  font-size: 16px;\n  font-weight: 700;\n  font-family: var(--font-heading);\n  color: var(--color-fire-500);\n  margin-bottom: var(--space-4);\n  padding-bottom: var(--space-2);\n  border-bottom: 1px solid var(--color-wood-600);\n}\n\n.club-info-grid {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.club-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n}\n\n.club-info-label {\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.club-info-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  line-height: 1.4;\n}\n\n.club-contacts {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.club-divider {\n  height: 1px;\n  background: var(--color-wood-600);\n  margin: var(--space-1) 0;\n}\n\n/* Map link */\n.map-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  margin-top: var(--space-3);\n  padding: var(--space-2) var(--space-4);\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-parchment-100);\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  border: none;\n  border-radius: var(--radius-lg);\n  text-decoration: none;\n  transition: all var(--transition-fast);\n  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.3);\n}\n\n.map-link:hover {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.4);\n}\n\n.map-link:active {\n  transform: translateY(0);\n}\n\n/* Developer section */\n.developer-section {\n  margin-top: var(--space-4);\n  padding-top: var(--space-4);\n  border-top: 1px dashed var(--color-wood-600);\n}\n\n.developer-hint {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  margin-bottom: var(--space-3);\n  line-height: 1.4;\n}\n\n.contact-button--developer {\n  background: var(--color-wood-700);\n  margin-top: 0;\n}\n\n.contact-button--developer:hover {\n  background: var(--color-wood-800);\n}\n\n@media (min-width: 768px) {\n  .profile-content {\n    max-width: 640px;\n    margin: 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
